import { Section } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Button, Card, Stack, Text } from 'braid-design-system';
import { useNavigate, useParams } from 'react-router';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface SalariesSearchSectionProps {
  model: Pick<SalariesTabModel, 'companyName'>;
  isSalariesByRole?: boolean;
}

export const SalariesListingSection = ({
  model,
  isSalariesByRole = false,
}: SalariesSearchSectionProps) => {
  const { companyName } = model;
  const { t } = useTranslations(translations);
  const navigate = useNavigate();
  const params = useParams();
  return (
    <Section
      mode={'view'}
      heading={
        isSalariesByRole
          ? t('More companyName salaries', { companyName })
          : t('Salary at companyName', { companyName })
      }
      padding={'none'}
    >
      <Card>
        <Stack space="small">
          <Button
            onClick={() => {
              void navigate(
                `/companies/${params.companySlug}/salaries/role-alias`,
              );
            }}
          >
            view salaries by role page
          </Button>
          <Text>Placeholder to show the role listing</Text>
        </Stack>
      </Card>
    </Section>
  );
};
